import { Payload } from "@neworbit/redux-helpers";

import { Dispatch } from "redux";

import { loadAndTrack } from "redux-request-loading/dist/actions";

import { orgStructureApi } from "../referralForm/OrgStructureApi";

import { OrgLevel } from "../../model";

import * as actions from "./actionTypes";

export type PhysiotherapyReferralFormAction = ({ type: typeof actions.LOAD_ORG_STRUCTURES_SUCCESS } & Payload<OrgLevel[]>);

export const loadOrgStructureSuccess = (payload: OrgLevel[]): PhysiotherapyReferralFormAction => ({
    payload,
    type: actions.LOAD_ORG_STRUCTURES_SUCCESS
});

export function loadOrgStructure(parentId?: string) {
    return async (dispatch: Dispatch) => {
        const orgLevels = await loadAndTrack(dispatch, "loadOrgStructures", orgStructureApi.getAll(parentId));
        dispatch(loadOrgStructureSuccess(orgLevels));
    };
}
